import { render, staticRenderFns } from "./Framework.vue?vue&type=template&id=026471ec&"
import script from "./Framework.vue?vue&type=script&lang=js&"
export * from "./Framework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports